// An announcement's message as text and links, for rendering without HTML:
// "[link text](https://...)" or "[link text](/in-app/page)", and bare
// http(s):// addresses. Each part is { text } or { text, href, internal }.

const LINK = /\[([^\]]+)\]\(((?:https?:\/\/|\/)[^)\s]+)\)|(https?:\/\/[^\s<>()]+[^\s<>().,;:!?'"])/g;

export function announcementParts(message) {
  const text = String(message || '');
  const parts = [];
  let last = 0;
  let m;
  LINK.lastIndex = 0;
  while ((m = LINK.exec(text)) !== null) {
    if (m.index > last) parts.push({ text: text.slice(last, m.index) });
    const href = m[2] || m[3];
    parts.push({ text: m[1] || m[3], href, internal: href.startsWith('/') });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
}

/** The message's plain text (link markup replaced by the link text). */
export function announcementPlain(message) {
  return announcementParts(message).map(p => p.text).join('');
}

/**
 * An older announcement (title + message + link) as one message: what the editor
 * shows, and what the banner and list render.
 */
export function announcementMessage(a) {
  if (!a) return '';
  const title = String(a.title || '').trim();
  const message = String(a.message || '').trim();
  let text = message || title;
  // The title was derived from the message (or there is none): don't repeat it.
  if (message && title && !announcementPlain(message).startsWith(title.replace(/\.\.\.$/, ''))) {
    text = `${title} — ${message}`;
  }
  if (a.link_url) text += ` [${a.link_label || 'See details'}](${a.link_url})`;
  return text;
}
